<template>
<div>
<div class="panal mt-20">
<div class="panal-header">Parent Data </div>
<div class="alert alert-warning text-center mt-2"> <font-awesome-icon icon="info" />  Kindly make sure that you're applying with correct data </div>


<form name="formParent" @submit.prevent="handleRegister">
  <div>
 <h6 class="blocked">Arabic Name</h6>
  <div class="row">
 
    <div class="col-12 col-md-3 mb-1">
      
      <input type="text" class="form-control su-border" placeholder="First name" v-model="ApplicantData.FirstNameAR">
    </div>
    <div class="col-12 col-md-3 mb-1">
      <input type="text" class="form-control su-border" placeholder="Second name" v-model="ApplicantData.SecondNameAR">
    </div>
    <div class="col-12 col-md-2 mb-1">
      <input type="text" class="form-control su-border" placeholder="third name" v-model="ApplicantData.ThirdNameAR">
    </div>
     <div class="col-12 col-md-2 mb-1">
      <input type="text" class="form-control su-border" placeholder="third name" v-model="ApplicantData.FamilyNameAR">
    </div>
    <div class="col-12 col-md-2 mb-1">
      <input type="text" class="form-control su-border" placeholder="fourth name" v-model="ApplicantData.LastNameAR">
    </div>
  </div> 
  <h6 class=" mt-20">English Name</h6>
  <div class="row">
 
    <div class="col-12 col-md-3 mb-1">
      <input type="text" class="form-control su-border" placeholder="First name" v-model="ApplicantData.FirstNameEN" >
    </div>
    <div class="col-12 col-md-3 mb-1">
      <input type="text" class="form-control su-border" placeholder="Second name" v-model="ApplicantData.SecondNameEN">
    </div>
    <div class="col-12 col-md-2 mb-1">
      <input type="text" class="form-control su-border" placeholder="Third name" v-model="ApplicantData.ThirdNameEN">
      
    </div>
    <div class="col-12 col-md-2 mb-1">
      <input type="text" class="form-control su-border" placeholder="Family name" v-model="ApplicantData.FamilyNameEN">
      
    </div>
    <div class="col-12 col-md-2 mb-1">
      <input type="text" class="form-control su-border" placeholder="Last name" v-model="ApplicantData.LastNameEN" >
    </div>
  </div>


<div class="row">

        <div class="col-12 col-md-6 mb-1">
        <h6 class="mt-20">National ID</h6>
        <input type="text" name="NationalId" v-validate="'required|digits:14'" class="form-control su-border" placeholder="123-123-456" v-model="ApplicantData.ParentNationID">
        <div v-if="submitted && errors.has('NationalId')" class="alert-danger">{{errors.first('NationalId')}}</div>
 
      </div>
        <div class="col-12 col-md-6 mb-1">
        <h6 class=" mt-20">Email</h6>
         <input type="email" name="email" v-validate="'required|email|max:50'" class="form-control su-border" placeholder="Email@email.com" v-model="ApplicantData.ParentEmail">
         <div v-if="submitted && errors.has('email')" class="alert-danger">{{errors.first('email')}}</div>

        </div>
    </div>
<div class="row">

        <div class="col-12 col-md-6 mb-1">
        <h6 class="mt-20">Parent Job</h6>
        <input type="text" class="form-control su-border" placeholder="Your parent Profession" v-model="ApplicantData.ParentJob">
        </div>
        <div class="col-12 col-md-6 mb-1">
        <h6 class=" mt-20">Parent Phone</h6>
         <input type="text" name="Phone" v-validate="'required|digits:11'" class="form-control su-border" placeholder="012-123-456" v-model="ApplicantData.ParentPhone">
         <div v-if="submitted && errors.has('Phone')" class="alert-danger">{{errors.first('Phone')}}</div>

        </div>
    </div>

<div class="row mt-20 text-center" >
 <div class="col">
 <button class="btn btn-primary text-center" type="submit"  :disabled="loading">
   <span v-show="loading" class="spinner-border spinner-border-sm"></span>
   Save </button>
 </div>

  </div>
</div>
</form>
   <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">{{message}}</div>

</div>
</div>

</template>

<script>
   import {
    ApplicantParent
    } from '../../models/Applicant';
    import ApplicantDataService from "../../services/Applicant/ApplicantData.services";

export default {
        name: 'PersonalParent' ,
        data(){
          return{
            ApplicantData : new ApplicantParent(),
            
            message: '',
            submitted:false,
            loading: false,
            successful: false,

          }
        },

    
 computed: {
    currentUser() {
           return this.$store.state.auth.user;
      },
  reviewApplication() {
        return this.$store.state.auth.renderReview
      }
  },
  mounted(){
 
    ApplicantDataService.GetApplicantParent(this.currentUser.UserIDSerial).then(Response =>{
                  
     
                  this.ApplicantData =new  ApplicantParent(Response.data.ApplicantID ,Response.data.ParentFirstNameEN,Response.data.ParentSecondNameEN,Response.data.ParentThirdNameEN,
                  Response.data.ParentFamilyNameEN,Response.data.ParentLastNameEN,
                  Response.data.ParentFirstNameAR,Response.data.ParentSecondNameAR,Response.data.ParentThirdNameAR,Response.data.ParentFamilyNameAR,Response.data.ParentLastNameAR,Response.data.ParentNationID,
                  Response.data.ParentJob,Response.data.ParentEmail,Response.data.ParentPhone)
                 
                })
  },
  methods:{
    isArabicChars(text) {
      var arregex = /^[\u0621-\u064A\s\p{N}]+$/;
      return arregex.test(text);
    },
  handleRegister() {
     this.message = '';
        this.submitted = true;
       if(!this.isArabicChars(this.ApplicantData.FirstNameAR)){
         alert('You are not using arabic letters For First name Arabic')
       }
      else if(!this.isArabicChars(this.ApplicantData.SecondNameAR)){
         alert('You are not using arabic letters For Second name Arabic')
       }
      else if(!this.isArabicChars(this.ApplicantData.ThirdNameAR)){
         alert('You are not using arabic letters For Third name Arabic')
       }
      else if(!this.isArabicChars(this.ApplicantData.FamilyNameAR)){
         alert('You are not using arabic letters For Family name Arabic')
       }
      else if(!this.isArabicChars(this.ApplicantData.LastNameAR)){
         alert('You are not using arabic letters For Last name Arabic')
       }
      else if(this.isArabicChars(this.ApplicantData.FirstNameEN)){
         alert('You are using arabic letters For Second name English')
       }
      else if(this.isArabicChars(this.ApplicantData.SecondNameEN)){
         alert('You are using arabic letters For Second name English')
       }
      else if(this.isArabicChars(this.ApplicantData.ThirdNameEN)){
         alert('You are using arabic letters For Third name English')
       }
      else if(this.isArabicChars(this.ApplicantData.FamilyNameEN)){
         alert('You are using arabic letters For Family name English')
       }
      else if(this.isArabicChars(this.ApplicantData.LastNameEN)){
         alert('You are using arabic letters For Last name English')
       }
      
       else{

        this.$validator.validate().then(isValid => {
          if (isValid) {
       
            this.ApplicantData.ApplicantID = this.currentUser.UserIDSerial
            this.loading= true;
                      this.$store.dispatch('auth/Review', this.reviewApplication+1 )

            ApplicantDataService.PostParentData(this.ApplicantData).then(
              res => {
                this.message = res.data;
                this.successful = true;
                this.loading = false;
                ApplicantDataService.GetApplicantParent(this.currentUser.UserIDSerial).then(Response =>{
                  
                  this.ApplicantData =new  ApplicantParent(Response.data.ApplicantID ,Response.data.ParentFirstNameEN,Response.data.ParentSecondNameEN,Response.data.ParentThirdNameEN,
                  Response.data.ParentFamilyNameEN,Response.data.ParentLastNameEN,
                  Response.data.ParentFirstNameAR,Response.data.ParentSecondNameAR,Response.data.ParentThirdNameAR,Response.data.ParentFamilyNameAR,Response.data.ParentLastNameAR,Response.data.ParentNationID,
                  Response.data.ParentJob,Response.data.ParentEmail,Response.data.ParentPhone)
                 
                 
                })
              },
              error => {
               this.message =
               (error.response && error.response.data && error.response.data.Message) ||
                 error.message ||  
                   error.toString();
               this.successful = false;
               this.loading = false;
              }
            );
            }
          })
          }
  }
  }
  }
</script> 

<style scoped>

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 50px 0px;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.mt-20{
  margin-top:20px;
}
.mt-40{
  margin-top:40px;
}

th{
font-weight:bold;
}
.text-center{
    text-align:center !important;
}
h6{
    color:#949494;
}

.su-border {
    border-color: #3D8FE3 !important;
    background: #F1F9FF !important;
}

input:disabled{
  background-color: bisque !important;
}
form{
  margin: 10px;
}

</style>